import React, { useContext, useMemo } from 'react';
import styled from 'styled-components';
import qs from 'qs';
import { FormattedMessage } from 'react-intl';
import { useLocation } from 'react-router';
import { LocaleContext } from 'utils/OwnIntlProvider';
import Logo from 'Common/Components/Logo';
import { ScreenWrapper } from './Login';
import ResetPasswordContainer from '../components/ResetPassword';
import { SignInButton } from './ForgotPassword';
import FormWrapper from '../components/views/FormWrapper';
import SupportText from '../components/views/SupportText';

const Title = styled.span`
  font-size: 24px;
  font-weight: 500;
  color: ${(props) => props.theme.gray1};
  padding: 8px 0 16px;
  margin-right: auto;
`;

const InvalidToken = styled.div`
  text-align: center;
  font-size: 14px;
  color: ${(props) => props.theme.fontColor};
  padding: 16px 0;
  display: block;
  margin: 60px 10px;
`;

const ResetPassword = () => {
  const location = useLocation();
  const context = useContext(LocaleContext);
  const query = useMemo(
    () => qs.parse(location.search, { ignoreQueryPrefix: true }),
    [location.search]
  );

  const switchLanguage = (lng: string) => {
    localStorage.setItem('locale', lng);
    context.selectLanguage(lng);
  };

  return (
    <ScreenWrapper>
      <FormWrapper>
        <Logo padding="16px" />
        {!query.token ? (
          <InvalidToken>
            <FormattedMessage
              defaultMessage="This session expired or your link is not valid. Please request a new link <link>here</link>"
              values={{
                link: (text: React.ReactNode) => (
                  <a href="/forgot-password">{text}</a>
                ),
              }}
            />
          </InvalidToken>
        ) : (
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              width: '100%',
            }}
          >
            <Title>
              <FormattedMessage defaultMessage="Reset your password" />
            </Title>
            <ResetPasswordContainer token={String(query.token)} />
            <div css="text-align: center; margin-top: 8px;margin-bottom: 25px;">
              <SignInButton type="link" href="/login" css="padding: 0;">
                <FormattedMessage defaultMessage="Go back to sign in" />
              </SignInButton>
            </div>
          </div>
        )}
        <SupportText
          selectedLang={context.locale}
          changeLang={switchLanguage}
        />
      </FormWrapper>
    </ScreenWrapper>
  );
};

export default ResetPassword;
